import { Skeleton } from "antd";

import Header from "containers/pmaOnboarding/components/stages/header";

const PmaLoading = () => {
  return (
    <>
      <Header />
      <div className=" flex justify-center">
        <Skeleton.Input />
      </div>
      <div className="relative px-10  mt-5 z-10">
        <div className="flex flex-col gap-8 z-[1]">
          <div className="flex gap-3 items-center">
            <Skeleton.Button active shape="circle" />
            <Skeleton.Input active className="!h-5 !min-w-0 !w-20" />
          </div>
          <div className="flex gap-3 items-center">
            <Skeleton.Button active shape="circle" />
            <Skeleton.Input active className="!h-5 !min-w-0 !w-20" />
          </div>
          <div className="flex gap-3 items-center">
            <Skeleton.Button active shape="circle" />
            <Skeleton.Input active className="!h-5 !min-w-0 !w-20" />
          </div>
          <div className="flex gap-3 items-center">
            <Skeleton.Button active shape="circle" />
            <Skeleton.Input active className="!h-5 !min-w-0 !w-20" />
          </div>
          <div className="flex gap-3 items-center">
            <Skeleton.Button active shape="circle" />
            <Skeleton.Input active className="!h-5 !min-w-0 !w-20" />
          </div>
        </div>
        <div className="absolute right-[54px] bg-gray--6 w-1 h-7 top-[34px]" />
        <div className="absolute right-[54px] bg-gray--6 w-1 h-7 top-[98px]" />
        <div className="absolute right-[54px] bg-gray--6 w-1 h-7 top-[162px]" />
        <div className="absolute right-[54px] bg-gray--6 w-1 h-7 top-[226px]" />
      </div>
      <div className="p-5 fixed bottom-0 max-w-2xl w-full">
        <Skeleton.Input active block className="!h-10" />
      </div>
    </>
  );
};
export default PmaLoading;
